import React from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import {
  Appbar, Card, Title, Paragraph,
} from 'react-native-paper';
import { useNavigation } from '@react-navigation/native';

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  card: {
    margin: 16,
  },
  title: {
    fontSize: 24,
    marginBottom: 16,
  },
  subtitle: {
    fontSize: 18,
    marginTop: 16,
    marginBottom: 8,
  },
  paragraph: {
    fontSize: 14,
    lineHeight: 20,
    textAlign: 'justify',
  },
  bulletRow: {
    flexDirection: 'row',
    paddingLeft: 8,
    marginBottom: 4,
  },
  bullet: {
    fontSize: 14,
    lineHeight: 20,
    marginRight: 8,
  },
  bulletText: {
    fontSize: 14,
    lineHeight: 20,
    textAlign: 'justify',
    flex: 1,
  },
});

// eslint-disable-next-line react/prop-types
function BulletItem({ children }) {
  return (
    <View style={styles.bulletRow}>
      <Paragraph style={styles.bullet}>{'\u2022'}</Paragraph>
      <Paragraph style={styles.bulletText}>{children}</Paragraph>
    </View>
  );
}

function PrivacyPolicyScreen() {
  const navigation = useNavigation();

  return (
    <>
      <Appbar.Header>
        <Appbar.BackAction onPress={() => navigation.goBack()} />
        <Appbar.Content title="Politique de Confidentialité" />
      </Appbar.Header>
      <ScrollView style={styles.container}>
        <Card style={styles.card}>
          <Card.Content>
            <Paragraph style={styles.paragraph}>
              Dernière mise à jour : 6 février 2026
            </Paragraph>

            <Paragraph style={styles.paragraph}>
              L'application KCB (Karate Club Bethoncourt), soucieuse des droits des individus et dans une volonté de transparence, a mis en place une politique reprenant l'ensemble des traitements de données personnelles, des finalités poursuivies et des moyens d'action à la disposition des individus.
            </Paragraph>

            <Title style={styles.subtitle}>
              1. Identité du Responsable du traitement
            </Title>
            <Paragraph style={styles.paragraph}>
              Les données sont collectées par Karate Club Bethoncourt (KCB), situé à Bethoncourt, France, et joignable à l'adresse email contact@karateclubbethoncourt.fr.
            </Paragraph>

            <Title style={styles.subtitle}>
              2. Données personnelles collectées
            </Title>
            <Paragraph style={styles.paragraph}>
              Dans le cadre de l'utilisation de l'application KCB, nous pouvons collecter les catégories de données suivantes :
            </Paragraph>
            <BulletItem>
              Données d'identification : Nom, prénom, adresse email, date de naissance, genre, grade, licence.
            </BulletItem>
            <BulletItem>
              Données de connexion : Adresse IP, logs de connexion, type d'appareil.
            </BulletItem>
            <BulletItem>
              Données de géolocalisation : Position GPS du conducteur pendant toute la durée d'un trajet effectué dans le cadre de ses missions, y compris lorsque l'application fonctionne en arrière-plan ou est fermée. Cette collecte cesse automatiquement dès la fin du trajet.
            </BulletItem>
            <BulletItem>
              Données relatives à l'utilisation de l'application : Actions effectuées, écrans consultés, temps passé.
            </BulletItem>

            <Title style={styles.subtitle}>
              3. Finalités du traitement des données
            </Title>
            <Paragraph style={styles.paragraph}>
              Vos données sont collectées pour les objectifs suivants :
            </Paragraph>
            <BulletItem>
              Fourniture du service : Création et gestion de votre compte utilisateur, authentification, inscription aux événements.
            </BulletItem>
            <BulletItem>
              Suivi des trajets : Collecte de la position GPS du conducteur pendant ses trajets, y compris en arrière-plan, afin de permettre le suivi en temps réel et la bonne réalisation des missions. Un consentement explicite est demandé avant toute activation de ce suivi.
            </BulletItem>
            <BulletItem>
              Amélioration de notre service : Analyse de l'utilisation de l'application pour corriger des bugs et améliorer l'expérience utilisateur.
            </BulletItem>
            <BulletItem>
              Communication : Envoi de notifications push (avec votre consentement), réponse à vos demandes de support.
            </BulletItem>
            <BulletItem>
              Sécurité : Prévention des fraudes et sécurisation de l'application.
            </BulletItem>

            <Title style={styles.subtitle}>
              4. Géolocalisation en arrière-plan
            </Title>
            <Paragraph style={styles.paragraph}>
              Lorsqu'un conducteur démarre un trajet, l'application KCB peut continuer à collecter sa position GPS même lorsque l'application est en arrière-plan ou fermée, afin de permettre le suivi en temps réel du trajet par les organisateurs et les personnes en attente du conducteur. Avant toute activation de cette fonctionnalité, un écran d'information dédié est présenté au conducteur, qui doit donner son consentement explicite. Cette collecte s'arrête automatiquement dès que le trajet est marqué comme terminé, et le conducteur peut à tout moment désactiver le suivi.
            </Paragraph>

            <Title style={styles.subtitle}>
              5. Base légale du traitement
            </Title>
            <Paragraph style={styles.paragraph}>
              Le traitement de vos données repose sur :
            </Paragraph>
            <BulletItem>
              L'exécution d'un contrat : Pour la fourniture des services principaux de l'application.
            </BulletItem>
            <BulletItem>
              Votre consentement : Pour des finalités spécifiques comme les notifications push et la collecte de votre position GPS, y compris en arrière-plan, lors des trajets.
            </BulletItem>
            <BulletItem>
              Notre intérêt légitime : Pour l'amélioration de nos services et la sécurité de l'application.
            </BulletItem>

            <Title style={styles.subtitle}>
              6. Destinataires des données
            </Title>
            <Paragraph style={styles.paragraph}>
              Vos données personnelles peuvent être transmises à nos équipes internes (uniquement les personnes habilitées). Nous ne partageons pas vos données avec des tiers.
            </Paragraph>

            <Title style={styles.subtitle}>
              7. Durée de conservation des données
            </Title>
            <Paragraph style={styles.paragraph}>
              Vos données sont conservées pour la durée strictement nécessaire à la réalisation des finalités pour lesquelles elles ont été collectées. Les données de votre compte sont conservées tant que votre compte est actif.
            </Paragraph>

            <Title style={styles.subtitle}>
              8. Droits des utilisateurs
            </Title>
            <Paragraph style={styles.paragraph}>
              Conformément au RGPD, vous disposez des droits suivants : droit d'accès, de rectification, à l'effacement, à la limitation du traitement, à la portabilité et d'opposition. Pour exercer ces droits, vous pouvez nous contacter à contact@karateclubbethoncourt.fr.
            </Paragraph>

            <Title style={styles.subtitle}>
              9. Sécurité des données
            </Title>
            <Paragraph style={styles.paragraph}>
              Nous mettons en œuvre les mesures techniques et organisationnelles appropriées pour garantir un niveau de sécurité adapté au risque.
            </Paragraph>

            <Title style={styles.subtitle}>
              10. Transfert de données hors Union Européenne
            </Title>
            <Paragraph style={styles.paragraph}>
              Vos données ne sont pas transférées hors de l'Union Européenne.
            </Paragraph>
          </Card.Content>
        </Card>
      </ScrollView>
    </>
  );
}

export default PrivacyPolicyScreen;
